import { DataExportRequestTypes } from "event-definitions"

export function useDataExportRequestTypes() {
    return DataExportRequestTypes.call({ dataExportRequestTypes: [] })
}
